import { Geometry } from "react-migration/domains/sites/typings/Geometry";
import bbox from "@turf/bbox";

/** Getting the zoom level for satellite image calculated by the following steps:
 * 1. calculating boundig box from site's geometry using turf bbox function
 * as a result we are getting 4 values: minX, minY, maxX, maxY
 * 2. calculating horizontal and vertical distances then getting zoom level
 * based on the minimum extent of the bounding box.
 * The logarithm base 2 of the ratio (360 / horizontal|vertical extent)
 * provides a way to estimate the zoom level. The given value should be rounded down
 * to get an integer and limit it to a max of 20.
 */

export function calculateZoomLevel(geometry: Geometry): number {
  const siteBoundingBox: number[] = bbox(geometry);
  const [minLon, minLat, maxLon, maxLat] = siteBoundingBox;

  const horizontalDistance = maxLon - minLon;
  const verticalDistance = maxLat - minLat;
  const worldWidth = 360; // Full extent of the Earth

  const lonZoomFactor = Math.log2(worldWidth / horizontalDistance);
  const latZoomFactor = Math.log2(worldWidth / verticalDistance);

  const zoom = Math.floor(Math.min(lonZoomFactor, latZoomFactor));
  const zoomLevel = Math.min(20, zoom); // Limit zoom to a maximum of 20
  return zoomLevel;
}
